import { h, JSX } from 'preact';

import cx from 'clsx';

import { DotsLoader } from '@shared/components/core';

import styles from './Button.module.scss';

export interface IButtonProps {
	className?: string;
	children?: h.JSX.Element | null | string;
	disabled?: boolean;
	loading?: boolean;
	variant?: 'primary' | 'secondary' | 'default' | 'link' | 'danger' | 'icon';
	onClick?: (event: JSX.TargetedMouseEvent<HTMLButtonElement>) => void;
	id?: string;
	onMouseEnter?: () => void;
	onMouseLeave?: () => void;
	onBlur?: () => void;
}

const Button = ({
	children,
	className,
	disabled = false,
	loading = false,
	onClick,
	variant = 'default',
	...props
}: IButtonProps) => {
	const handleClick = (event: JSX.TargetedMouseEvent<HTMLButtonElement>) => {
		if (!(disabled || loading) && onClick) {
			onClick(event);
		}
	};
	return (
		<button
			className={cx(
				'border-radius2',
				{
					[styles.disabled]: disabled,
					pointer: !disabled,
				},
				styles.button,
				{
					[styles.ripple]: variant === 'primary' || variant === 'secondary',
				},
				'border-radius2 pointer',
				{
					'bg-primary color-primaryLabel p3 h5 bold': variant === 'primary',
					'bg-primaryLight color-primary p3 h5 bold': variant === 'secondary',
					'bg-transparent color-labelDark h6 p0 lighter':
						variant === 'link' || variant === 'icon',
					'bg-error color-error h5 bold': variant === 'danger',
					'bg-white color-labelDark h5 bold': variant === 'default',
				},
				className,
			)}
			onClick={handleClick}
			disabled={disabled}
			{...props}
		>
			{loading ? <DotsLoader /> : children}
		</button>
	);
};

export default Button;
